import api from './utils/api';

class FiltersService {
  // MÉTODO 1: Listar todos os filtros disponíveis (já existe)
  async listFilters() {
    const result = await api.get('/filters');
    return result.data;
  }

  async listFiltersGender(gender) {
    const result = await api.get(`/filters/gender/${gender}`);
    return result.data;
  }

  async listFiltersGenderFilter(gender) {
    const result = await api.get(`/filters/genderfilter/${gender}`);
    return result.data;
  }

  // MÉTODO 3: Listar filtros já salvos do modelo
  async getModelFilters() {
    const result = await api.get('/model-filter');
    return result.data;
  }

  // MÉTODO 4: Salvar/atualizar filtro do modelo (já existe)
  async upsertModelFilter(data) {
    const result = await api.put('/model-filter', data);
    return result;
  }

  // MÉTODO 5: Deletar filtro do modelo
  async deleteModelFilter(id) {
    await api.delete(`/model-filter/${id}`);
  }

  // Métodos de idiomas (já existiam)
  async listLanguagesModel(id) {
    const result = await api.get(`/model-languages/${id}`);
    return result.data;
  }

  async upsertModelLanguages(data) {
    const result = await api.put('/model-languages', data);
    return result;
  }

  async deleteModelLanguages(id) {
    await api.delete(`/model-languages/${id}`);
  }
}

export default new FiltersService();
